import React, { useEffect } from "react";

const ChatWidgetComponent = () => {
  useEffect(() => {
    const script = document.createElement("script");
    const baseUrl = process.env.REACT_APP_BACKEND_URL;
    script.src =
      `${baseUrl}/api/widgets/chat-widget.js?organization_id=org_32AyYjsNDEojsPpV3y5mggD3LNt&widget_id=c3337f7d-0534-43b7-98a8-02ee8257fc75`;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Optional cleanup if needed
      document.body.removeChild(script);
    };
  }, []);

  return <div id="chat-widget-container" />;
};

export default ChatWidgetComponent;
